import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';
import React from 'react';

import { colors } from 'src/themes/colors';

const useStyles = makeStyles({
  container: {
    marginLeft: 20,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  arrowButton: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 26,
    width: 28,
    padding: 4,
    border: '2px solid #D5E1ED',
    cursor: 'pointer',
    '&:focus': {
      outline: 0,
    },
    '&:disabled': {
      color: colors.gray6,
      borderColor: colors.gray9,
      cursor: 'not-allowed',
    },
  },
  arrowButtonPrev: {
    borderRadius: '4px 0 0 4px',
  },
  arrowButtonNext: {
    borderRadius: '0 4px 4px 0',
  },
  arrowIcon: {
    fontSize: 22,
  },
  dateName: {
    width: 'auto',
    height: 'auto',
    margin: '0 10px',
    padding: '5px 20px',
    borderRadius: 4,
    fontWeight: 800,
    fontSize: 14,
    cursor: 'default',
  },
});

export const PaginationButtons = ({
  canDecrement,
  canIncrement,
  handleDecrement,
  handleIncrement,
  date,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Tooltip title="Previous" placement="top" arrow>
        <button
          aria-label="previous"
          className={`${classes.arrowButton} ${classes.arrowButtonPrev}`}
          disabled={!canDecrement}
          onClick={handleDecrement}
        >
          <ChevronLeft className={classes.arrowIcon} />
        </button>
      </Tooltip>

      <p className={`${classes.arrowButton} ${classes.dateName}`}>{date}</p>

      <Tooltip title="Next" placement="top" arrow>
        <button
          aria-label="next"
          className={`${classes.arrowButton} ${classes.arrowButtonNext}`}
          disabled={!canIncrement}
          onClick={handleIncrement}
        >
          <ChevronRight className={classes.arrowIcon} />
        </button>
      </Tooltip>
    </div>
  );
};
